import { render, staticRenderFns } from "./rate.vue?vue&type=template&id=728114fc&"
import script from "./rate.vue?vue&type=script&lang=js&"
export * from "./rate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('728114fc')) {
      api.createRecord('728114fc', component.options)
    } else {
      api.reload('728114fc', component.options)
    }
    module.hot.accept("./rate.vue?vue&type=template&id=728114fc&", function () {
      api.rerender('728114fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shop/child/rate.vue"
export default component.exports